import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import { ITripSource, TripSourceDetails } from "../../../../TripSources"

export default function TripSourceDetailsPage() {
	const { tripSource, revalidate } = useOutletContext<{
		tripSource: ITripSource
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Trip Source Details</title>
			</Helmet>
			<TripSourceDetails tripSource={tripSource} onChange={revalidate} />
		</>
	)
}
